import React from 'react';
import { Form, Input } from 'antd';


export default (props) => {

    const { index } = props;

    return (
        <Form.Item
            name={[index, "link"]}
            label='Link'
            rules={[{ required: true, message: 'Link is required.' }]}
        >
            <Input placeholder='Link' />
        </Form.Item>
    )
}